namespace TabAurous.SalesOrder {
    export namespace OrderItemsForWorkOrderService {
        export const baseUrl = 'SalesOrder/OrderItemsForWorkOrder';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<SalesOrderItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "SalesOrder/OrderItemsForWorkOrder/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>OrderItemsForWorkOrderService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
